import ContactSpreadsheetImport from './ContactSpreadsheetImport';
import withModal from '../../../../components/global/modal/withModal';

export const CONTACT_SPREADSHEET_IMPORT_MODAL =
  'CONTACT_SPREADSHEET_IMPORT_MODAL';

const ContactSpreadsheetImportModal = withModal(ContactSpreadsheetImport, {
  name: CONTACT_SPREADSHEET_IMPORT_MODAL,
  size: 'md',
  type: 'full',
  hideHeader: true,
  shouldCloseOnOverlayClick: false,
  overlayClassName: 'z-modal-max',
});

export default ContactSpreadsheetImportModal;
